import {makeAutoObservable} from "mobx";

class ModifyOrderStore {
    orderId = 0;
    orderAddress = undefined;

    constructor() {
        makeAutoObservable(this)
    }
}

export default new ModifyOrderStore();